import { render, staticRenderFns } from "./SelectStudyCategoryContent.vue?vue&type=template&id=062ac176&scoped=true&lang=pug&"
import script from "./SelectStudyCategoryContent.vue?vue&type=script&lang=ts&"
export * from "./SelectStudyCategoryContent.vue?vue&type=script&lang=ts&"
import style0 from "./SelectStudyCategoryContent.vue?vue&type=style&index=0&id=062ac176&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062ac176",
  null
  
)

export default component.exports